import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const LLV = '/cham-cong/lich-lam-viec'
const CLV = '/cham-cong/ca-lam-viec'

// Lấy danh sách lịch làm việc
export function layDanhSachLichLamViec(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${LLV}/`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy lịch làm việc của user
export function layLichLamViecNguoiDung(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${LLV}/nhan-vien/${userId}`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách ca làm việc
export function layDanhSachCaLamViec() {
  try {
    return axiosApi.get(`${CLV}/`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo lịch làm việc
export function taoLichLamViec(params: any) {
  try {
    return axiosApi.post(`${LLV}/`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật lịch làm việc
export function capNhatLichLamViec(scheduleId: number, params: any) {
  try {
    return axiosApi.put(`${LLV}/${scheduleId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa lịch làm việc
export function xoaLichLamViec(scheduleId: number) {
  try {
    return axiosApi.delete(`${LLV}/${scheduleId}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
